// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__38phr","delete":"styles_delete__mikLK","update":"styles_update__3Jjv9","add":"styles_add__24E8R"};